import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { hexToRGB } from 'src/components/Marketplace/helpers';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '20px',
    paddingTop: '20px',
    borderTop: `1px solid ${hexToRGB(
      theme.typography.userInterfaceElements?.divider.default.colorStyle.color,
      theme.typography.userInterfaceElements?.divider.default.colorStyle.opacity,
    )}`,
    borderBottomRightRadius: '6px',
    borderBottomLeftRadius: '6px',

    [theme.breakpoints.down('md')]: {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  resetButton: {
    fontSize: theme.typography.fontSizes?.medium,
    fontWeight: '500',
    color: theme.typography.button?.clearFilter?.text.default.colorStyle.color,
    opacity: theme.typography.button?.clearFilter?.text.default.colorStyle.opacity,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'underline',

    '&:hover': {
      color: `${theme.typography.button?.clearFilter?.text.hover.colorStyle.color} !important`,
      opacity: theme.typography.button?.clearFilter?.text.hover.colorStyle.opacity,
    },
    '&.notActive': {
      color: `${theme.typography.button?.clearFilter?.text.disabled.colorStyle.color} !important`,
      opacity: theme.typography.button?.clearFilter?.text.disabled.colorStyle.opacity,
      pointerEvents: 'none',
    },
  },
  applyButton: {
    padding: '17px 27px !important',
    background: `${hexToRGB(
      theme.typography.button?.primaryAction?.background.default.colorStyle.color,
      theme.typography.button?.primaryAction?.background.default.colorStyle.opacity,
    )} !important`,
    color: theme.typography.button?.primaryAction?.text.default.colorStyle.color,
    opacity: theme.typography.button?.primaryAction?.text.default.colorStyle.opacity,
    border: `1px solid ${hexToRGB(
      theme.typography.button?.primaryAction?.border.default.colorStyle.color,
      theme.typography.button?.primaryAction?.border.default.colorStyle.opacity,
    )} !important`,
    borderRadius: theme.typography.button?.primaryAction?.cornerRadius,
    fontWeight: '500',
    cursor: 'pointer',
    fontSize: theme.typography.fontSizes?.medium,
    transition: 'all 0.3s ease',
    boxShadow: 'none',
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      padding: '12px 20px !important',
      height: 44,
    },
    '&:hover': {
      backgroundColor: `${theme.typography.button?.primaryAction?.background.hover.colorStyle.color} !important`,
      opacity: theme.typography.button?.primaryAction?.background.hover.colorStyle.opacity,
      border: `1px solid ${hexToRGB(
        theme.typography.button?.primaryAction?.border.hover.colorStyle.color,
        theme.typography.button?.primaryAction?.border.hover.colorStyle.opacity,
      )} !important`,
    },
    '&.notActive': {
      border: `1px solid ${hexToRGB(
        theme.typography.button?.primaryAction?.border.disabled.colorStyle.color,
        theme.typography.button?.primaryAction?.border.disabled.colorStyle.opacity,
      )} !important`,
      backgroundColor: theme.typography.button?.primaryAction?.background.disabled.colorStyle.color,
      opacity: theme.typography.button?.primaryAction?.background.disabled.colorStyle.opacity,
      pointerEvents: 'none',
    },
  },
}));
